import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
    // color: 'red',
  },
}));

const DiasApartirDaEmissaoField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);

  let value = '-';

  if (record) {
    if (record.record.dhEmis) {
      const dataAtual = new Date(moment(new Date()).endOf('day').format());

      const dataPagamento = new Date(
        moment(new Date(record.record.dhEmis)).endOf('day').format(),
      );

      const delta = dataAtual.getTime() - dataPagamento.getTime();

      value = parseInt(delta / (24 * 60 * 60 * 1000), 10);
    }
  }

  return <Typography className={classes.text}>{value}</Typography>;
};

export default DiasApartirDaEmissaoField;
